/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Naveen Aithal",
  title: "Hi all, I'm Naveen Aithal",
  subTitle: emoji(
    "A full-stack web developer with rich experience in the MEAN and MERN stacks 🚀. and have a passion for creating dynamic and interactive web experiences that are both visually stunning and easy to use."
  ),
  resumeLink: "../../assets/images/naveen_aithal_u_resume_image.png", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/naveenaithal",
  linkedin: "https://www.linkedin.com/in/naveenaithal/",
  gmail: "naveenaithal44@gmail.com",
  facebook: "https://www.facebook.com/naveenaithal44?mibextid=ZbWKwL",
  instagram: "https://www.instagram.com/naveen_aithal?igsh=cTE3Mzc5dWtpNTA3",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Proficient in full-stack development, seamlessly integrating front-end and back-end technologies for cohesive and user-friendly web applications."
    ),
    emoji(
      "⚡ Extensive expertise in diverse programming languages and frameworks, ensuring the creation of robust, scalable, and high-performance solutions."
    ),
    emoji(
      "⚡ Dedicated to innovation and staying updated on industry trends, with a focus on crafting dynamic web applications that enhance user engagement and contribute to overall business success."
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },

    {
      skillName: "AI/ML",
      fontAwesomeClassname: "fab fa-think-peaks"
    },

    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Birla Institute of Technology And Science, Pilani",
      logo: require("./assets/images/bits_logo.jpg"),
      subHeader: "M. Tech. Cloud Computing",
      duration: "Jan 2024 - Jan 2026",
      desc: "Unveiling the Transformative Potential of Cloud Computing Education for Professional Growth."
    },
    {
      schoolName: "Canara Engineering College",
      logo: require("./assets/images/canaraEnginerringCollege.png"),
      subHeader: "Mechanical Engineering",
      duration: "July 2017 - August 2021",
      desc: "Bachelors in Mechanical Engineering attended various workshops on Python, 3D Printing held at a university level"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "95%"
    },
    {
      Stack: "Programming",
      progressPercentage: "80%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Software Engineer II",
      company: "JPMorgan Chase",
      companylogo: require("./assets/images/jpmc.jpg"),
      date: "January 2025 – Present",
      desc: "• Contributing to the development of enterprise-grade applications with a focus on Spring Boot, React, and Angular.",
      descBullets: [
        "Developing robust backend microservices using Spring Boot, ensuring scalability and reliability.",
        "Creating dynamic, user-friendly interfaces with React and Angular to enhance user experience.",
        "Implementing comprehensive testing strategies, including unit tests, integration tests, and end-to-end tests.",
        "Collaborating with cross-functional teams to deliver high-quality software solutions.",
        "Mentoring team members and fostering a culture of technical excellence.",
        "Maintaining well-documented codebases to ensure long-term maintainability and knowledge sharing."
      ]
    },
    {
      role: "Software Engineer",
      company: "CGI",
      companylogo: require("./assets/images/cgi.jpg"),
      date: "April 2023 – Jan 2025",
      desc: "• Led the development of the Retail360 ERP application, driving successful client adoption.",
      descBullets: [
        "Proficient in backend development using NestJS, handling complex API tasks.",
        "Orchestrated comprehensive testing strategies, including unit tests, end-to-end tests, and integration tests.",
        "Designed user-friendly interfaces with React and TypeScript, improving the user experience.",
        "Mentored colleagues and provided support during technical challenges.",
        "Resolved complex issues, maintained detailed documentation for knowledge sharing."
      ]
    },
    {
      role: "Software Engineer",
      company: "Ahana Systems and Solutions Pvt Ltd.",
      companylogo: require("./assets/images/ahana.jpg"),
      date: "August 2021 – Feb 2023",
      desc: "Experienced Full Stack Developer adept at crafting robust and responsive web applications, having successfully contributed to multiple projects",
      descBullets: [
        "Developed a Responsive Web application for Vendors to manage their invoice transactions using MEAN Stack",
        "Ensured the quality of the work met client and management specifications",
        "Participated with business analyst to understand the business requirements includes converting mock-ups or wireframes into singlepage applications.",
        "Developed a Responsive Web Application using React while managing the State through Redux. This Bot Monitoring Application helped clients to make efficient use of their RPA Bots."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  // subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/scamradar.png"),
      projectName: "Scam Scanner",
      projectDesc:
        "Scam Scanner is a full-stack cyber safety platform built to help people quickly identify, report, and avoid online scams. The platform combines community-powered reporting with AI-assisted risk analysis so users can check suspicious links, messages, phone numbers, and scam stories before taking action. Users can submit scam incidents with screenshots or evidence, browse categorized reports, and search by keyword, fraud type, or date to find patterns and similar cases. A dedicated risk checker uses intelligent analysis to classify content and provide a clear risk level with practical safety guidance. The system also includes role-based authentication, user profiles, and an admin moderation flow to keep reports trustworthy and useful. Scam Scanner is available across web and mobile experiences, making scam awareness and prevention accessible from anywhere. By turning scattered scam incidents into a searchable and verified knowledge base, Scam Scanner empowers individuals and communities to stay informed, reduce financial loss, and respond faster to emerging digital threats.",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://www.scamscanner.in/"
        }
      ]
    },
    {
      image: require("./assets/images/botMonitoring.png"),
      projectName: "Bot Monitor System",
      projectDesc:
        "Bot Monitor System is a web-based tool that allows users to register new bots and assign specific processes to them. The application is designed to monitor the bots in real-time, providing users with detailed information on the utilization and performance of the bots. Users can check past and present utilization of the bots through dashboard charts, which provide a comprehensive view of the bots usage. Additionally, users can download the utilization logs of the bots in excel format, providing them with a detailed report on the bots performance. The system has four different types of dashboards that allow users to view the bots utilization, providing them with a comprehensive understanding of the bots usage and performance. This feature enables users to optimize the usage of their bots, resulting in more efficient and cost-effective automation."
      // footerLink: [
      //   {
      //     name: "Visit Website",
      //     url: "http://nextu.se/"
      //   }
      // ]
    },

    {
      image: require("./assets/images/vendorManagement.png"),
      projectName: "Vendor Management",
      projectDesc:
        "The Vendor Management Portal is a web-based tool for managing vendors and their invoices. It allows vendors to register, raise purchase orders and non-purchase orders, and track the status of their invoices. Preparers can add additional details to invoices, and checkers can verify them before they are approved by an admin."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  // title: emoji("Achievements And Certifications 🏆 "),
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "",

  achievementsCards: [
    {
      title: "Silver Award",

      image: require("./assets/images/silver_certificate.jpg"),
      imageAlt: "Silver Award",
      subtitle:
        '"Silver Award" symbolizes My commitment to delivering exceptional work.',
      footerLink: [
        {
          name: "Achievement",
          url: "https://drive.google.com/file/d/1g-5SWgqEAxWpeB0Z8oSy_igcMA241Hdm/view?usp=sharing"
        }
      ]
    },
    {
      title: "Championing Partnership and Quality",

      image: require("./assets/images/applaud.jpg"),
      imageAlt: "Championing Partnership and Quality",
      subtitle:
        "This Applaud  reflects my commitment to the core values of Partnership and Quality",
      footerLink: [
        {
          name: "Achievement",
          url: "https://drive.google.com/file/d/16nPWloTOyvk9GV3RuvFHdP6h7-0PLVuA/view?usp=sharing"
        }
      ]
    },
    {
      title: "Shining Star Award",

      image: require("./assets/images/shining_star.jpg"),
      imageAlt: "Shining Star Award",
      subtitle:
        "Being honored with the 'Shining Star Award' for my exceptional work performance!",
      footerLink: [
        {
          name: "Achievement",
          url: "https://drive.google.com/file/d/17iUlUNWr-62JV62PkP_AbA6GZPoQmRBb/view?usp=sharing"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me "),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  // number: "+92-0000000000",
  email_address: "naveenaithal44@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "naveenaithal44", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  achievementSection,
  bigProjects,
  blogSection,
  contactInfo,
  educationInfo,
  greeting,
  illustration,
  isHireable,
  openSource,
  podcastSection,
  skillsSection,
  socialMediaLinks,
  splashScreen,
  talkSection,
  techStack,
  twitterDetails,
  workExperiences
};
